import DOMPurify from 'dompurify';

export default defineNuxtPlugin(async () => {
  let htmlSanitizer;

  if (import.meta.server) {
    const { JSDOM } = await import('jsdom');
    htmlSanitizer = DOMPurify(new JSDOM('').window);
  } else {
    htmlSanitizer = DOMPurify;
  }

  return { provide: { htmlSanitizer } };
});
